'use client';

import { c as _c } from "react/compiler-runtime";
import { HelpWidgetProvider as Provider, useHelpWidget } from './HelpWidgetContext';
import HelpWidget from './HelpWidget';
import FloatingChatIcon from '@/app/_components/FloatingChatIcon';

/**
 * HelpWidgetProvider wraps both the context provider and the widget component.
 * Use this in your layout to enable the help widget throughout the app.
 */
const HelpWidgetProvider = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HelpWidget />;
    t2 = <FloatingChatIcon />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <Provider>{children}{t1}{t2}</Provider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export { HelpWidgetProvider, useHelpWidget };